import styled, { keyframes } from "styled-components";

// Subtle shimmer animation (opacity pulse)
export const shimmer = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
    100% {
        opacity: 1;
    }
`;

export const ShimmerBox = styled.div`
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Secondary_Alpha};
    animation: ${shimmer} 2s ease-in-out infinite;
`;

// Full page skeleton container
export const SkeletonContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    background: theme.colors[theme.colorMode].canvas_Primary,
    overflow: "hidden",
}));

export const HeaderBar = styled(ShimmerBox)(({ theme }) => ({
    height: 60,
    width: "100%",
    borderRadius: theme.cornerRadius.medium,
}));

// Tabs skeleton - centered pill
export const TabsSection = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    padding: `${theme.spacing.medium}px 0`,
}));

export const TabsPill = styled(ShimmerBox)(({ theme }) => ({
    height: 42,
    width: 184,
    borderRadius: theme.cornerRadius.large,
    marginBottom: theme.spacing.medium,
    marginTop: theme.spacing.xLarge,
}));

export const TabContentWrapper = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
}));

export const ContentSection = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
    padding: theme.spacing.medium,
}));

export const ContentCard = styled(ShimmerBox)(({ theme }) => ({
    height: 200,
    width: "100%",
    borderRadius: theme.cornerRadius.large,
}));

export const BottomSection = styled.div(({ theme }) => ({
    marginTop: "auto",
    paddingTop: theme.spacing.xLarge,
}));

export const BottomButton = styled(ShimmerBox)(() => ({
    height: 72,
    width: "100%",
}));
